<template>
  <div class="registration-game">
    <div v-if="!completed" class="game-header">
      <button v-if="debug" class="btn btn-primary" @click="testComplete">test complete</button>
      <div class="game-content">
        <GameContainer :topicID="77" :compact="true" mode="registration" :allowSkip="false" @topicCompleted="topicCompleted" @incrementGameStepsShown="incrementGameStepsShown"/>
      </div>
      <div class="game-footer" v-if="showNextButton">
        <button class="btn btn-primary" type="button" @click="goToNextGame">Next Game</button>
      </div>
    </div>
    <div v-else class="game-completed">
      <h2>Congratulations!</h2>
      <p>You have completed the intro game.</p>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import GameContainer from '../views/GameContainer.vue';

const emit = defineEmits(['topicCompleted', 'incrementGameStepsShown']);

const showNextButton = ref(false);
const completed = ref(false);
const debug = ref(false);

function topicCompleted() {
  completed.value = true;
  emit('topicCompleted')
}

function incrementGameStepsShown() {
  emit('incrementGameStepsShown');
}

function testComplete() {
  completed.value = true
  emit('topicCompleted')
}

</script>

<style scoped>
.registration-game {
  display: flex;
  flex-direction: column;
}

.game-content {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  /* Add overflow if needed */
}

.game-footer {
  /* Remove position: fixed */
  background: #fff;
  border-top: 1px solid #eee;
  padding: 1rem;
  text-align: center;
  z-index: 10;
}
</style>